var gql = require("@apollo/client").gql;

const REVIEWS_UNIQUE_HOUSE_QUERY = gql`
	query reviewsProvidersUniqueHouseOne(
		$region_url: String
		$house_id: Int
		$sort: String
		$providerJoin: Boolean
	) {
		reviewsProvidersUniqueHouseOne(
			region_url: $region_url
			house_id: $house_id
			sort: $sort
			providerJoin: $providerJoin
		) {
			data {
				id
				title
				date
				rating_type
				review
				time_of_use
				services_of_use
				real
				provider {
					id
					name
				}
				author {
					id
					name
				}
				answers {
					list {
						id
						text
						type
						date
						user {
							id
							name
							description
							photo
						}
					}
				}
			}
		}
	}
`;

module.exports = REVIEWS_UNIQUE_HOUSE_QUERY;
